import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

/** Sidebar block layout id 1 */
const DeviationGrid3X3: React.FC<Props> = ({
  block,
  deviation: parentDeviation,
}) => {
  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block}>
      <DeviationSidebarGrid
        streamId={`sidebar-3x3-${block.contentType}`}
        deviations={block.deviations ?? []}
        parentDeviation={parentDeviation}
        maxRows={3}
      />
    </SidebarBlockWrapper>
  );
};
DeviationGrid3X3.displayName = 'DeviationGrid3X3';

export default DeviationGrid3X3;
